import {apiBase} from './ApiBase'

export const auth = async ({mail, password}) => {
  const result = await apiBase.post(`/login`, {mail, password})
  return result.data
}

export const me = async () => {
  try {
    const result = await apiBase.get(`/me`)
    return result.data.data
  } catch (_) {
    return null
  }
}

export const entry = async ({user}) => {
  const result = await apiBase.post(`/entry`, { ...user.export() })
  return result.data
}

export const entryConfirm = async ({code}) => {
  const result = await apiBase.put(`/entry/confirm`, { code })
  return result.data
}

export const update = async ({user}) => {
  const result = await apiBase.put(`/user`, { ...user.export() })
  return result.data
}

export const resetPasswordRequest = async ({mail}) => {
  const result = await apiBase.post(`/password/change`, { mail })
  return result.data
}

export const resetPassword = async ({code, password}) => {
  const result = await apiBase.post(`/password/reset`, { code, password })
  return result.data
}

export const changePassword = async ({ password }) => {
  const result = await apiBase.put(`/password`, { password })
  return result.data
}
